import { ActionType, createAction, createAsyncAction } from 'typesafe-actions'

import { Deal, DealEmail, DealInfoData, IdIndexedDeals } from './types'

export const setDeals = createAction('/scenes/Dashboard/data/deals/SET_DEALS', (resolve) => (deals: IdIndexedDeals) =>
  resolve(deals)
)

export const fetchOneDealAsUser = createAsyncAction(
  '/scenes/Dashboard/data/deals/ONE_DEAL_AS_USER_FETCH_BEGIN',
  '/scenes/Dashboard/data/deals/ONE_DEAL_AS_USER_FETCH_SUCCESS',
  '/scenes/Dashboard/data/deals/ONE_DEAL_AS_USER_FETCH_FAILURE'
)<undefined, Deal, Error>()

export const setOneDeal = createAction('/scenes/Dashboard/data/deals/SET_ONE_DEAL', (resolve) => (deal: Deal) =>
  resolve(deal)
)
export const analyzeDealBegin = createAction(
  '/scenes/Dashboard/data/deals/ANALYZE_DEAL_BEGIN',
  (resolve) => (deal: Deal) => resolve(deal)
)

export const analyzeDealSuccess = createAction(
  '/scenes/Dashboard/data/deals/ANALYZE_DEAL_SUCCESS',
  (resolve) => (deal: Deal) => resolve(deal)
)

export const triggerDealReanalysisBegin = createAction(
  '/scenes/Dashboard/data/deals/DEAL_REANALYSIS_TRIGGER_BEGIN',
  (resolve) => (dealId: Deal['id'], isAdmin: boolean = false) => resolve({ dealId, isAdmin })
)

export const triggerDealReanalysisSuccess = createAction(
  '/scenes/Dashboard/data/deals/DEAL_REANALYSIS_TRIGGER_SUCCESS',
  (resolve) => (deal: Deal) => resolve(deal)
)

export const markDealAsNew = createAsyncAction(
  '/scenes/Dashboard/data/deals/MARK_DEAL_AS_NEW_BEGIN',
  '/scenes/Dashboard/data/deals/MARK_DEAL_AS_NEW_SUCCESS',
  '/scenes/Dashboard/data/deals/MARK_DEAL_AS_NEW_FAILURE'
)<Deal['id'], Deal, Error>()

export const deleteDeal = createAsyncAction(
  '/scenes/Dashboard/data/deals/DELETE_DEAL_AS_ADMIN_BEGIN',
  '/scenes/Dashboard/data/deals/DELETE_DEAL_AS_ADMIN_SUCCESS',
  '/scenes/Dashboard/data/deals/DELETE_USER_AS_ADMIN_DEAL_FAILURE'
)<Deal['id'], Deal['id'], Error>()

export const updateDealInfoBegin = createAction(
  '/scenes/Dashboard/data/deals/UPDATE_DEAL_INFO_BEGIN',
  (resolve) => (dealId: Deal['id'], dealInfo: DealInfoData) => resolve({ dealId, dealInfo })
)

export const updateDealInfoSuccess = createAction(
  '/scenes/Dashboard/data/deals/UPDATE_DEAL_INFO_SUCCESS',
  (resolve) => (deal: Deal) => resolve(deal)
)

export const emailDeal = createAsyncAction(
  '/scenes/Dashboard/data/deals/EMAIL_DEAL_BEGIN',
  '/scenes/Dashboard/data/deals/EMAIL_DEAL_SUCCESS',
  '/scenes/Dashboard/data/deals/EMAIL_DEAL_FAILURE'
)<DealEmail, void, Error>()

export type DealAction = ActionType<
  | typeof setDeals
  | typeof fetchOneDealAsUser
  | typeof setOneDeal
  | typeof markDealAsNew
  | typeof analyzeDealBegin
  | typeof analyzeDealSuccess
  | typeof triggerDealReanalysisBegin
  | typeof triggerDealReanalysisSuccess
  | typeof deleteDeal
  | typeof updateDealInfoBegin
  | typeof updateDealInfoSuccess
  | typeof emailDeal
>
